import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Preloader from '../../Components/Common/Preloader';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import { getCreativePreview } from '../../slices/analytics/thunk';
import { toggleCreativeModal } from '../../slices/analytics/reducer';

function CreativesList() {
  const dispatch = useDispatch();
  const selectStates = createSelector(state => state, state => ({
    creativesData: state.Analytics.creativesData,
    creativesLoader: state.Analytics.creativesLoader,
  }));
  const { creativesData, creativesLoader } = useSelector(selectStates);
  
  const tableRef = useRef();
  useEffect(() => {
    if (creativesData) {
      try {
        const table = $(tableRef.current).DataTable({
          data: creativesData,
          columns: [
            {
              data: 'size',
              title: 'Size',
              render: (data, type, row) => {
                return `<div class='d-flex align-items-center justify-content-between'><p class='m-0'>${data}</p><i class='ri-eye-fill text-gray creative'></i></div>`
              }
            },
            {
              data: 'versionName',
              title: 'Version',
            },
            {
              data: 'impression',
              title: 'Impressions',
            },
            {
              data: 'click',
              title: 'Clicks'
            },
            {
              data: 'ctr',
              title: 'Click Through Rate'
            }
          ],
          responsive: true,
          destroy: true,
          language: {
            search: "<i class='ri-search-line search-icon'></i>",
            searchPlaceholder: "Search for users..."
          },
          paging: true,
          info: false,
        });

        table.on("click", ".creative", async function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            dispatch(toggleCreativeModal());
            dispatch(getCreativePreview(data));
          }
        });

        return function () {
          table.destroy();
        };
      } catch (error) {
      }
    }
  }, [creativesData]);
  return (
    <React.Fragment>
      {creativesLoader ?
        <Card className='card card-height-100 align-items-center justify-content-center'>
          <Preloader isComponentLoader={true} width={150} height={150} />
        </Card>
        : creativesData ?
        <Card>
          <CardHeader>
            <p className='m-0'>Creative List</p>
          </CardHeader>
          <CardBody>
            <div className='table-responsive table-card mt-0'>
              <table
                className="align-middle table-nowrap mb-0 table"
                style={{ width: "100%" }}
                ref={tableRef}
              >
                <thead className="table-light"></thead>
                <tbody></tbody>
              </table>
            </div>
          </CardBody>
        </Card> : null
      }
    </React.Fragment>
  )
}

export default CreativesList
